export default defineNuxtPlugin(nuxtApp => {
    const store = useGlobalStore();

    nuxtApp.hook('i18n:localeSwitched', async ({ oldLocale, newLocale }) => {
        setTimeout(() => store.setLanguageCode(newLocale), 1500);
    });
})